import { render, staticRenderFns } from "./MarketplacePurchases.vue?vue&type=template&id=0b850fc3"
import script from "./MarketplacePurchases.vue?vue&type=script&lang=js"
export * from "./MarketplacePurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports